import cn from 'clsx'

import { IconTwitter, IconFacebook, IconYoutube, IconInstagramColored } from '@tracklib/kit'
import styles from './socialicons.css'

type SocialIconsProps = {
  share?: boolean
  twitterShareText?: string
  className?: string
}

const SocialIcons = ({ share, twitterShareText, className }: SocialIconsProps): JSX.Element => {
  const fbUrl = share ? 'https://www.facebook.com/sharer/sharer.php?u=tracklib.com' : 'https://facebook.com/tracklib/'
  const twitterUrl = share
    ? `http://twitter.com/share?text=${twitterShareText || ''}&url=https://www.tracklib.com&via=tracklib`
    : 'https://twitter.com/Tracklib'
  return (
    <div className={cn(styles.socialIcons, className)}>
      <a href={fbUrl} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
        <IconFacebook className={styles.facebook} />
      </a>
      {!share && (
        <a href="https://instagram.com/tracklib" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
          <IconInstagramColored />
        </a>
      )}
      <a href={twitterUrl} target="_blank" rel="noopener noreferrer" aria-label="Twitter">
        <IconTwitter className={styles.twitter} />
      </a>
      {!share && (
        <a href="https://youtube.com/tracklib" target="_blank" rel="noopener noreferrer" aria-label="Youtube">
          <IconYoutube className={styles.youtube} />
        </a>
      )}
    </div>
  )
}

export default SocialIcons
